import store from "@/store"
import * as Cookie from "@/localCache/cookie";

/**
 * @description 路由守卫
 */
export function beforeEach(to, from, next) {
    // 如果是需要登录才能访问的页面，且当前还没有登录，则跳转首页登录
    if (!isAuthenticated() && to.meta.needLogin) {
        next('/home')
    } else {
        next()
    }
}

/**
 * @description 判断是否已登录
 * @returns {boolean}
 */
function isAuthenticated() {
    if (store.getters.token) {
        return true
    } else {
        let token = Cookie.getToken();
        if (token) store.commit('SET_TOKEN', token);
        return !!token;
    }
}
